import { GaugeIcon } from "lucide-react";

export const EmptyChart = () => (
  <div className="h-[400px] flex items-center justify-center border rounded-lg bg-gray-50 dark:bg-gray-800">
    <div className="text-center text-gray-500 dark:text-gray-400">
      <GaugeIcon className="w-16 h-16 mx-auto mb-4 opacity-50" />
      <p className="text-lg">Upload a data log to visualize your dyno results</p>
      <p className="text-sm mt-2 text-gray-400 dark:text-gray-500">
        Your performance data will be displayed here
      </p>
    </div>
  </div>
);
